import React, { useEffect, useState } from 'react'
import api from '../../../../../services/api'
import Form, { Input, Select } from '../../../../../components/Form'
import { useHistory } from 'react-router-dom'
import { useToast } from '../../../../../hooks/toast'
import { useLoading } from '../../../../../hooks/loading'
import { useUpdateDataTable } from '../../../../../hooks/dataTable'
import { apiCreate, apiUpdate } from '../../domain/api'
import {
  nameActions,
  AGENCY_USER_ROLE_ENUM,
  AGENCY_USER_ROLE_MAP
} from '../../domain/info'
import { FormContainer } from './styles'

type IsOpenInModalProps = {
  handleOnClose: () => void
  agency_id: number
}

type AgencyUserData = {
  id?: string
  agency_id: number
  name: string
  email: string
  password?: string
  role: AGENCY_USER_ROLE_ENUM
}

type AgencyUserResponseData = {
  agency_id: number
  name: string
  email: string
  password?: string
  role: AGENCY_USER_ROLE_ENUM
}

type TypesFormProps = {
  isOpenInModal?: false | IsOpenInModalProps
  initialValues?: AgencyUserData & {
    idUpdate: number
  }
  typeForm: 'create' | 'update'
}

export const FormAgencyUser = ({
  isOpenInModal,
  initialValues,
  typeForm
}: TypesFormProps): JSX.Element => {
  const { addToast } = useToast()
  const history = useHistory()
  const { updateDataTable } = useUpdateDataTable()

  const [defaultValues, setDefaultValues] = useState<AgencyUserResponseData>()

  useEffect(() => {
    if (initialValues) {
      setDefaultValues({
        agency_id: initialValues.agency_id,
        name: initialValues.name,
        email: initialValues.email,
        role: initialValues.role
      })
    }
  }, [initialValues, typeForm])

  const { activeLoading, disableLoading } = useLoading()

  const onSubmitForm = async (data: AgencyUserResponseData) => {
    const id = initialValues?.idUpdate

    try {
      if (typeForm === 'create') {
        if (isOpenInModal) {
          try {
            const dataCreate = {
              ...data,
              agency_id: isOpenInModal.agency_id
            }
            activeLoading()
            await api.post(apiCreate(), dataCreate)
            disableLoading()
            updateDataTable()
            addToast({
              type: 'success',
              title: 'Registro criado',
              description: 'Registro criado com sucesso'
            })
            isOpenInModal.handleOnClose()
          } catch (error) {
            addToast({
              type: 'error',
              title: 'Erro ao adicionar o registro',
              description:
                'Ocorreu um erro ao fazer cadastro, por favor, tente novamente.'
            })
            disableLoading()
            updateDataTable()
          }
        } else {
          try {
            const dataCreate = {
              ...data
            }
            activeLoading()
            await api.post(apiCreate(), dataCreate)
            disableLoading()
            updateDataTable()
            addToast({
              type: 'success',
              title: 'Registro criado',
              description: 'Registro criado com sucesso'
            })
            history.push(nameActions.read.to)
          } catch (error) {
            addToast({
              type: 'error',
              title: 'Erro ao adicionar o registro',
              description:
                'Ocorreu um erro ao fazer cadastro, por favor, tente novamente.'
            })
            disableLoading()
            updateDataTable()
          }
        }
      } else {
        if (isOpenInModal) {
          const dataUpdate = {
            ...data,
            agency_id: isOpenInModal.agency_id
          }

          try {
            activeLoading()
            await api.put(apiUpdate(String(id)), dataUpdate)
            updateDataTable()
            disableLoading()
            addToast({
              type: 'success',
              title: 'Registro atualizado',
              description: 'Registro alterado com sucesso'
            })
            isOpenInModal.handleOnClose()
          } catch (error) {
            history.push(nameActions.read.to)
            addToast({
              type: 'error',
              title: 'Erro ao atualizar o registro',
              description:
                'Ocorreu um erro ao fazer a atualização, por favor, tente novamente.'
            })
          }
        } else {
          const dataUpdate = {
            ...data
          }

          try {
            activeLoading()
            await api.put(apiUpdate(String(id)), dataUpdate)
            updateDataTable()
            disableLoading()
            history.push(nameActions.read.to)
            addToast({
              type: 'success',
              title: 'Registro atualizado',
              description: 'Registro alterado com sucesso'
            })
          } catch (error) {
            history.push(nameActions.read.to)
            addToast({
              type: 'error',
              title: 'Erro ao atualizar o registro',
              description:
                'Ocorreu um erro ao fazer a atualização, por favor, tente novamente.'
            })
          }
        }
      }
      disableLoading()
    } catch (err) {
      if (typeForm === 'create') {
        addToast({
          type: 'error',
          title: 'Erro no cadastro',
          description:
            'Ocorreu um erro ao fazer cadastro, por favor, tente novamente.'
        })
        if (isOpenInModal) isOpenInModal.handleOnClose()
      }
    }
  }

  return (
    <Form onSubmit={onSubmitForm} defaultValues={defaultValues}>
      <>
        <div className="card mb-5 mb-xl-10">
          <FormContainer className="form">
            <div className="row mb-5">
              <Input
                name={'name'}
                label="Nome"
                rules={{ required: true }}
                className="col-md-3"
              />
              <Input
                name={'email'}
                label="Email"
                rules={{ required: true }}
                className="col-md-3"
              />
              <Input
                type="password"
                name={'password'}
                label="Senha"
                rules={{ required: typeForm === 'create' }}
                className="col-md-3"
              />
              <Select
                className="col-md-3"
                name={'role'}
                label="Grupo de usuário"
                options={Object.entries(AGENCY_USER_ROLE_MAP).map(
                  ([key, label]) => ({
                    name: label,
                    value: key
                  })
                )}
                blank
                rules={{ required: true }}
              />
            </div>
          </FormContainer>
          <div className="card-footer d-flex justify-content-end py-6 px-9">
            <button type="submit" className="btn btn-primary">
              Salvar
            </button>
          </div>
        </div>
      </>
    </Form>
  )
}
